import { Fragment } from 'react';
import type { LucideIcon } from 'lucide-react';

import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandList,
  CommandSeparator
} from '@/components/ui/command';

import { FilterHeader } from './filter-header';
import { FilterGroupHeader } from './filter-group-header';
import { FilterItemComponent } from './filter-item';
import type { FilterGroup } from '../model/types';

interface FilterContentProps {
  groups: FilterGroup[];
  searchPlaceholder: string;
  emptyText: string;
  showSelectAll: boolean;
  selectedCount: number;
  isAllSelected: boolean;
  onSelectAll: () => void;
  onClearAll: () => void;
  getGroupSelectedCount: (group: FilterGroup) => number;
  onSelectGroup: (group: FilterGroup) => void;
  onClearGroup: (group: FilterGroup) => void;
  isItemSelected: (itemId: string) => boolean;
  onToggleItem: (itemId: string) => void;
  defaultIcon?: LucideIcon;
}

export function FilterContent({
  groups,
  searchPlaceholder,
  emptyText,
  showSelectAll,
  selectedCount,
  isAllSelected,
  onSelectAll,
  onClearAll,
  getGroupSelectedCount,
  onSelectGroup,
  onClearGroup,
  isItemSelected,
  onToggleItem,
  defaultIcon
}: FilterContentProps) {
  return (
    <Command>
      {showSelectAll && (
        <FilterHeader
          selectedCount={selectedCount}
          isAllSelected={isAllSelected}
          onSelectAll={onSelectAll}
          onClearAll={onClearAll}
        />
      )}
      <CommandInput placeholder={searchPlaceholder} />
      <CommandList>
        <CommandEmpty>{emptyText}</CommandEmpty>
        {groups.map((group, index) => (
          <Fragment key={group.groupId}>
            {index > 0 && <CommandSeparator />}
            <CommandGroup className="overflow-visible">
              <FilterGroupHeader
                group={group}
                selectedCount={getGroupSelectedCount(group)}
                onSelectAll={() => onSelectGroup(group)}
                onClear={() => onClearGroup(group)}
                showSelectAll={showSelectAll}
              />
              {group.items.map((item) => (
                <FilterItemComponent
                  key={item.id}
                  item={item}
                  groupName={group.group}
                  isSelected={isItemSelected(item.id)}
                  onToggle={() => onToggleItem(item.id)}
                  defaultIcon={defaultIcon}
                />
              ))}
            </CommandGroup>
          </Fragment>
        ))}
      </CommandList>
    </Command>
  );
}
